export default __webpack_public_path__ + "static/logo-cipolla-eabf5cbfcb7f5d451383660223c2df14.webp";